module.exports = __webpack_public_path__ + "img/179963.2671be96.png";